import { EventEmitter, Directive, ElementRef, Renderer2, Input, Output, HostListener, NgModule } from '@angular/core';

/**
 * [mt-doubleClickDisabled] directive is used to disable a button while waiting for an asynchronous action to complete.
 */
import * as ɵngcc0 from '@angular/core';
class MtPreventDoubleClickDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        /**
         * Emit an event to the parent component so that the onchanges will fire when overriding the click
         */
        this.doubleClickIsDisabledChange = new EventEmitter();
    }
    /**
     * Override the click and set disabled to true until handle via the promise by the developer.
     */
    onClick() {
        // Need to set a default time out here.  With out this when the button triggers a form submit
        // disabling it to fast will stop the form submit event
        // Reference from comment here https://stackoverflow.com/q/46317618/5997923
        setTimeout(() => {
            this.doubleClickIsDisabled = true;
            this.doubleClickIsDisabledChange.emit(this.doubleClickIsDisabled);
        });
    }
    /**
     * Listens for updates on the input property and toggles it's disabled status.
     * @param changes
     */
    ngOnChanges(changes) {
        if (changes.doubleClickIsDisabled) {
            this.toggleButton(changes.doubleClickIsDisabled.currentValue);
        }
    }
    /**
     * Takes in a boolean variable and toggles the elements disabled status.
     * @param isDisabled
     */
    toggleButton(isDisabled) {
        if (isDisabled) {
            this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
        }
        else {
            this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
        }
    }
}
MtPreventDoubleClickDirective.ɵfac = function MtPreventDoubleClickDirective_Factory(t) { return new (t || MtPreventDoubleClickDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MtPreventDoubleClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MtPreventDoubleClickDirective, selectors: [["", "mt-doubleClickDisabled", ""]], hostBindings: function MtPreventDoubleClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MtPreventDoubleClickDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { doubleClickIsDisabled: "doubleClickIsDisabled" }, outputs: { doubleClickIsDisabledChange: "doubleClickIsDisabledChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MtPreventDoubleClickDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
MtPreventDoubleClickDirective.propDecorators = {
    doubleClickIsDisabled: [{ type: Input }],
    doubleClickIsDisabledChange: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click', [],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtPreventDoubleClickDirective, [{
        type: Directive,
        args: [{
                selector: '[mt-doubleClickDisabled]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { doubleClickIsDisabledChange: [{
            type: Output
        }], 
    /**
     * Override the click and set disabled to true until handle via the promise by the developer.
     */
    onClick: [{
            type: HostListener,
            args: ['click', []]
        }], doubleClickIsDisabled: [{
            type: Input
        }] }); })();

class MtPreventDoubleClickButtonModule {
}
MtPreventDoubleClickButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtPreventDoubleClickButtonModule });
MtPreventDoubleClickButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtPreventDoubleClickButtonModule_Factory(t) { return new (t || MtPreventDoubleClickButtonModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtPreventDoubleClickButtonModule, { declarations: [MtPreventDoubleClickDirective], exports: [MtPreventDoubleClickDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtPreventDoubleClickButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [MtPreventDoubleClickDirective],
                exports: [MtPreventDoubleClickDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtPreventDoubleClickButtonModule, MtPreventDoubleClickDirective };

//# sourceMappingURL=mt-ng2-disable-double-click.js.map